module.exports = __webpack_public_path__ + "assets/img/home-scdx.46134846.png";